var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-range-picker',_vm._g(_vm._b({model:{value:(_vm.newVal),callback:function ($$v) {_vm.newVal=$$v},expression:"newVal"}},'a-range-picker',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }